import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BeneficiaryShareChangeTypeEnum } from './beneficiary-share-change-type.enum';
import { BeneficiaryShareChangeType } from './beneficiary-share-change-type';
import { FixedDecimalPipe } from '../../pipes/fixed-decimal.pipe';

@Component({
  selector: 'app-beneficiary-submission-share-change',
  standalone: true,
  imports: [FixedDecimalPipe],
  templateUrl: './beneficiary-submission-share-change.component.html',
  styleUrls: ['./beneficiary-submission-share-change.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BeneficiarySubmissionShareChangeComponent {
  @Input() change!: BeneficiaryShareChangeType;
  protected readonly BeneficiaryShareChangeTypeEnum = BeneficiaryShareChangeTypeEnum;
}
